import { render, staticRenderFns } from "./CustomerItem.vue?vue&type=template&id=91a870ae&scoped=true&"
import script from "./CustomerItem.vue?vue&type=script&lang=js&"
export * from "./CustomerItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomerItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerItem.vue?vue&type=style&index=1&id=91a870ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a870ae",
  null
  
)

export default component.exports